import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./DetailsPanel.scss";
import { isEmpty } from "lodash";
import { storeDetailScreenshots } from "../../data/storeDetailScreenshots/StoreDetailScreenshots";
import { districtDetailScreenshots } from "../../data/districtDetailScreenshots/DistrictDetailScreenshots";

const DetailsPanel = (props) => {
  const { clicked, districts } = props;

  const [targetPicked, setTargetPicked] = useState(null);
  // const [distInfoFound, setDistInfoFound] = useState(null);
  const [requiredScreenshot, setRequiredScreenshot] = useState("");

  const formatStoreDetails = (clickedObj = {}) => {
    let formatedDetails = {};
    if (clickedObj.data) {
      // store details
      if (clickedObj.data) {
        formatedDetails = { ...formatedDetails, type: "store" };
        formatedDetails = { ...formatedDetails, id: clickedObj.data[0] };
        formatedDetails = { ...formatedDetails, name: clickedObj.data[1] };
        formatedDetails = { ...formatedDetails, latitude: clickedObj.data[2] };
        formatedDetails = { ...formatedDetails, longitude: clickedObj.data[3] };
        formatedDetails = {
          ...formatedDetails,
          consumerDemographics: clickedObj.data[4],
        };
        formatedDetails = {
          ...formatedDetails,
          consumerInterest: clickedObj.data[5],
        };
        formatedDetails = {
          ...formatedDetails,
          storeSurrounding: clickedObj.data[6],
        };
        formatedDetails = {
          ...formatedDetails,
          footfall: clickedObj.data[7],
        };
        formatedDetails = { ...formatedDetails, index: clickedObj.index };
      }
    }
    return !isEmpty(formatedDetails) ? formatedDetails : null;
  };

  const formatDistrictDetails = (clickedObj = {}, infoFound = {}) => {
    let formatedDetails = {};
    // district details
    if (clickedObj) {
      formatedDetails = { ...formatedDetails, type: "district" };
      formatedDetails = {
        ...formatedDetails,
        name: clickedObj.ENAME,
      };
      formatedDetails = {
        ...formatedDetails,
        chineseName: clickedObj.TCNAME,
      };
      formatedDetails = {
        ...formatedDetails,
        index: clickedObj.index,
      };
      formatedDetails = {
        ...formatedDetails,
        shapeArea: clickedObj.SHAPE_Area,
      };
      formatedDetails = {
        ...formatedDetails,
        shapeLength: clickedObj.SHAPE_Length,
      };
      formatedDetails = { ...formatedDetails, id: infoFound.ID || null };
      formatedDetails = {
        ...formatedDetails,
        consumerDemographics: infoFound.consumerDemographics || null,
      };
      formatedDetails = {
        ...formatedDetails,
        consumerInterest: infoFound.consumerInterest || null,
      };
      formatedDetails = {
        ...formatedDetails,
        storeSurrounding: infoFound.storeSurrounding || null,
      };
      formatedDetails = {
        ...formatedDetails,
        footfall: infoFound.footfall || null,
      };
    }
    return !isEmpty(formatedDetails) ? formatedDetails : null;
  };

  useEffect(() => {
    if (!clicked) return;
    // clicked on a district
    if (clicked.object.properties) {
      const _targetName = clicked.object.properties.ENAME;
      const _distInfoFound = districts.filter(
        (dist) => dist.NAME.toUpperCase() === _targetName.toUpperCase()
      );
      const objInfoFound = !isEmpty(_distInfoFound) ? _distInfoFound[0] : {};
      setTargetPicked(
        formatDistrictDetails(clicked.object.properties, objInfoFound)
      );
    } else {
      // clicked on a store
      setTargetPicked(formatStoreDetails(clicked.object));
    }
  }, [clicked, districts]);

  useEffect(() => {
    if (!targetPicked) return;
    if (targetPicked.type === "store") {
      const _foundObj = storeDetailScreenshots.filter(
        (item) => `${item.id}` === `${targetPicked.id}`
      );
      if (_foundObj.length > 0) {
        // setRequiredScreenshot(require(`../../data/storeDetailScreenshots/${_foundObj[0].srcName}`));
        setRequiredScreenshot(
          `./data/storeDetailScreenshots/${_foundObj[0].srcName}`
        );
      } else {
        setRequiredScreenshot("");
      }
    } else {
      const _foundObj = districtDetailScreenshots.filter(
        (item) => `${item.id}` === `${targetPicked.id}`
      );
      if (_foundObj.length > 0) {
        // setRequiredScreenshot(require(`../../data/districtDetailScreenshots/${_foundObj[0].srcName}`));
        setRequiredScreenshot(
          `./data/districtDetailScreenshots/${_foundObj[0].srcName}`
        );
      } else {
        setRequiredScreenshot("");
      }
    }
  }, [targetPicked]);

  return (
    <div className="detailsPanel">
      {targetPicked && (
        <div className="targetDetailsWrap">
          {targetPicked.type && (
            <div className="targetType">{`${targetPicked.type}`}</div>
          )}
          <div className="targetName">
            {targetPicked.name}
            {targetPicked.chineseName && (
              <span className="targetChnName">
                ({targetPicked.chineseName})
              </span>
            )}
          </div>
          <div className="targetContent">
            {/* <div className="tarDetails">
              {targetPicked.longitude && (
                <div className="tarLng">
                  Longitude: {targetPicked.longitude}
                </div>
              )}
              {targetPicked.latitude && (
                <div className="tarLat">Latitude: {targetPicked.latitude}</div>
              )}
            </div> */}

            {requiredScreenshot && (
              <div className="graphPlaceWrap">
                <img
                  className="detailScreenshot"
                  src={requiredScreenshot}
                  alt="chart screenshot"
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

DetailsPanel.defaultProps = {
  clicked: {},
  districts: [],
};

DetailsPanel.propTypes = {
  clicked: PropTypes.object,
  districts: PropTypes.arrayOf(PropTypes.object),
};

export default DetailsPanel;
